export default __webpack_public_path__ + "static/media/menu_top.44add3f7.svg";